import styled from "styled-components";

import { StyledProxyBidWrapperProps } from "./ProxyBid.types";

const PROXY_BID_MOBILE_HEIGHT = "104px";

export const StyledProxyBidWrapper = styled.div<StyledProxyBidWrapperProps>`
	width: 100%;
	height: 48px;
	border-radius: ${(props) => props.theme.radii.lg};
	display: flex;
	position: relative;
	:focus-within {
		input {
			border: ${({ theme }) =>
					`2px solid ${theme.palette.hexFor("primary_accent_400")};`}
				${({ viewport }) =>
					!["xs", "sm"].includes(viewport?.currentSize)
						? "border-right: none;"
						: ""};
		}
	}
	${({ viewport }) => {
		const isMobileDevice = ["xs", "sm"].includes(viewport?.currentSize);
		return isMobileDevice
			? `flex-direction: column;
				height: ${PROXY_BID_MOBILE_HEIGHT};`
			: "";
	}}
`;
